import { motion } from "framer-motion";

export const PHONE = "587-783-1980";
export const TEL = "tel:+15877831980";
export const OWNER = "Tanya Bursova";
export const LOGO = "https://customer-assets.emergentagent.com/job_tanya-cleaning-yeg/artifacts/ek84xr4s_logo-tania-cleaning.png";
export const TANYA_PHOTO = "https://customer-assets.emergentagent.com/job_tanya-cleaning-yeg/artifacts/i4o2ffia_hf_20260707_221422_f4c48a00-7832-47ab-b178-e42676373d0d.png";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
